<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15YdA0x/images/cover.jpg?1684515201160" alt="This image is the cover for the book BIOLOGY AND GENERAL SCIENCE, National Teacher Examination Series (NTE)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">BIOLOGY AND GENERAL SCIENCE, National Teacher Examination Series (NTE)
      </h1>
      <p class="bookDescription body article font2">
        <p>The National Teacher/PRAXIS Examinations are designed to provide objective measurement of the knowledge, skills and abilities required of teachers. The Passbook® for the Biology and General Science exam provides hundreds of multiple-choice questions in the areas that will likely be covered on your upcoming certification exam, including but not limited to: basic principles of biology; anatomy and physiology; and other related areas.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        National Learning Corporation
      </h2>
      
      <p class="authorDescription body article">National Learning Corporation has been a leading publisher of test-preparation Passbooks® for more than 50 years, with 6,000 titles available across 22 series.  The Career Examination Series features thousands of titles designed to prepare test candidates for their upcoming civil-service job exam.  Each book in the Career Series offers practice through multiple-choice questions and answers in relevant subject areas, as well as informative texts to aid in understanding the study material.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      National Learning Corporation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0faaef2f